import { useDrawer } from '@cast/design-system';

import {
  CheckDetailsDrawer,
  CheckDetailsDrawerPayload,
} from './CheckDetailsDrawer';

export const useCheckDetailsDrawer = (onClose?: () => void) => {
  const { open } = useDrawer();

  const _open = (payload: CheckDetailsDrawerPayload) => {
    open({
      component: CheckDetailsDrawer,
      props: {
        ...payload,
        onClose,
      },
    });
  };

  return { open: _open };
};
